import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";


export const getCounter = createAsyncThunk(
    'aboutus/get-about-us',
    async (_, { rejectWithValue }) => {
        try {
            const contentData = await GET(API.GET_ABOUTUS_COUNTER);
            return contentData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getAboutus = createAsyncThunk(
    'aboutus',
    async (_, { rejectWithValue }) => {
        try {
            const contentData = await GET(API.GET_ABOUTUS);
            return contentData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);



export const getVissionMission= createAsyncThunk(
    'aboutus/get-ach-and-ack',
    async (_, { rejectWithValue }) => {
        try {
            const ach_and_ack = await GET(API.GET_VISSION_MISSION);
            return ach_and_ack;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Thunk for getting Add banners
export const getOurTeam= createAsyncThunk(
    'about-us/our-team',
    async (_, { rejectWithValue }) => {
        try {
            const whatmediadoData = await GET(API.GET_OUT_TEAM);
            return whatmediadoData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getpillar= createAsyncThunk(
    'about-us/our-pillar',
    async (_, { rejectWithValue }) => {
        try {
            const whatmediadoData = await GET(API.pillar);
            return whatmediadoData;

        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create the slice
const aboutusSlice = createSlice({
    name: "aboutus",
    initialState: {
        count:{},
        about_as:[],
        vission_mission:[],
        our_team:[],
        pillar:[],
        name: '',
        subname: '',
        image: '',
        error: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder


        .addCase(getCounter.pending, (state) => {
            state.status = 'loading';
            // console.log('State after pending', state);
        })
        .addCase(getCounter.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.count = action.payload?.data || {};
            // console.log('State after fulfilled', state);
        })
        .addCase(getCounter.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
            // console.log('State after rejected', state);
        })

         .addCase(getpillar.pending, (state) => {
            state.status = 'loading';
            // console.log('State after pending', state);
        })
        .addCase(getpillar.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.pillar = action.payload?.data || {};
            // console.log('State after fulfilled', state);
        })
        .addCase(getpillar.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
            // console.log('State after rejected', state);
        })

            .addCase(getVissionMission.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getVissionMission.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.vission_mission = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getVissionMission.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })


            .addCase(getOurTeam.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getOurTeam.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.our_team = action.payload?.data || [];
                // console.log('State after fulfilled', state);
            })
            .addCase(getOurTeam.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })

              .addCase(getAboutus.pending, (state) => {
                state.status = 'loading';
                // console.log('State after pending', state);
            })
            .addCase(getAboutus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.about_as = action.payload?.data || {};
                // console.log('State after fulfilled', state);
            })
            .addCase(getAboutus.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                // console.log('State after rejected', state);
            })
            
            
    },
});

export default aboutusSlice.reducer;


